import React from 'react';
import './App.css';
import Button from 'react-bootstrap/Button';
import LineArtBackground from './LineArtBackground';

function Apply() {

  return (
<div id="container" className="center has-lineart">
    <LineArtBackground variant="arc" />
    <section>
      <div id="divmesomespacesmall"></div>
    <h1 className="bold" id="gradienttext">Apply</h1>
    <p id="clientp">
    Are you interested in technology, business, and/or design? Or, perhaps, you’re interested in products in general and want to learn more about the product development pipeline from when an idea launches into a scalable&nbsp;feature/product!
    </p>

    <p id="clientp">
    Applications for the Fall 2026 semester have closed. Please check back next&nbsp;semester!
    </p>

    <Button id="button" disabled>Applications closed</Button>

    <p></p>

    <p id="clientp">
    Product Lab is Harvard’s premier student-run product management organization. Through training programs, real-world product experience, and industry mentorship, we introduce product management to problem-solvers from all backgrounds and help them grow into future product leaders. We’ve also opened up our competitive case team application to all (even students who have not completed the educational comp process in the Fall)! In the past, we’ve worked with companies such as Salesforce, Duolingo, Hubspot, and&nbsp;more!
    </p>

    <p id="clientp">
Still on the fence? Come to our Info Session &amp; Meet/Greet to learn more about our case teams and projects when the semester&nbsp;begins! We’ll post details on <a href="https://www.instagram.com/harvard.product/">@harvard.product</a> on Instagram, so follow for more info. More detailed information about the application will be shared on our <a href="https://five-hill-5b1.notion.site/APM-Applications-S-24-efb62bc2bbce4c3993b62f7dd31f8b25">Notion&nbsp;page</a> when applications&nbsp;reopen.
    </p>

    </section>
    </div>
    );
};

export default Apply;